<template>
  <BonusInfoPage />
</template>

<script setup lang="ts">
import BonusInfoPage from '@st/bonuses/components/BonusesInfoPage/BonusInfoPage.vue'

useSeoData('bonus-info')
</script>
